import { useEffect, useState } from "react";

import { MOBILE_BREAKPOINT } from "../Theme";

function viewportBelowMobileThreshhold() {
  return window.innerWidth < MOBILE_BREAKPOINT;
}

export const isMobile = viewportBelowMobileThreshhold;

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(viewportBelowMobileThreshhold());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(viewportBelowMobileThreshhold());
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return isMobile;
};
